<!-- <h2 mat-dialog-title class="h2tittle">Paste {{ inputType === 'json' ? 'JSON' : 'Text' }}</h2>

<mat-dialog-content style="padding: 0;">

    <textarea class="json-field"
        matInput
        [(ngModel)]="jsonText">
    </textarea>


    <div *ngIf="error" style="color: red; font-size: 12px;">
        {{ error }}
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-raised-button color="primary" (click)="submit()">Add</button>
</mat-dialog-actions> -->
<div cdkDrag cdkDragRootElement=".cdk-overlay-pane">
<h2 mat-dialog-title cdkDragHandle class="h2tittle">Paste {{ inputType === 'json' ? 'JSON' : 'Text' }}</h2>

<mat-dialog-content class="json-dialog-content">
    <div class="json-wrapper">
        <textarea
            class="json-field" 
            matInput
            [(ngModel)]="jsonText">
        </textarea>
        <span class="underline"></span>
    </div>

    <div *ngIf="error" style="color:red;font-size:12px;">
        {{ error }}
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end" >
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-raised-button color="primary" (click)="submit()">Add</button>
</mat-dialog-actions>
</div>